import { Calendar as CalendarIcon } from 'lucide-react';
import { type ControllerRenderProps, type Path } from 'react-hook-form';
import dayjs from 'dayjs';

import { Textarea } from '@/components/ui/textarea';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { FormControl } from '@/components/ui/form';

import { type IAdditionalFieldType } from '../../model';

const DynamicFieldInput = <
  T extends {
    additionalFields: { type: IAdditionalFieldType; value: string }[];
  },
>({
  type,
  field,
}: {
  type: IAdditionalFieldType;
  field: ControllerRenderProps<T, Path<T> & `additionalFields.${number}.value`>;
}) => {
  switch (type) {
    case 'note':
      return (
        <FormControl>
          <Textarea {...field} className="resize-none h-[80px]" />
        </FormControl>
      );
    case 'date':
      return (
        <Popover>
          <PopoverTrigger asChild>
            <div className="relative grow">
              <CalendarIcon className="absolute left-4 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
              <FormControl>
                <Input value={field.value ? dayjs(field.value).format('MMM DD, YYYY') : ''} className="pl-10" />
              </FormControl>
            </div>
          </PopoverTrigger>
          <PopoverContent className="w-80 p-2" align="start">
            <Calendar
              mode="single"
              selected={field.value ? new Date(field.value) : undefined}
              onSelect={(date) => field.onChange(date?.toISOString())}
              className="rounded-md border w-full"
            />
          </PopoverContent>
        </Popover>
      );
    default:
      return (
        <FormControl>
          <Input {...field} type="text" ref={field.ref} />
        </FormControl>
      );
  }
};

export default DynamicFieldInput;
